export enum LineType {
  SOLID = "solid",
  DASHED = "dashed",
  DOTS = "dots",
}

export const LINE_TYPE_DASH_MAP = new Map<LineType, number[]>([
  [LineType.SOLID, [0, 0]],
  [LineType.DASHED, [10, 5]],
  [LineType.DOTS, [5, 10]],
]);

const DASH_TO_LINE_TYPE_MAP = new Map<string, LineType>();
LINE_TYPE_DASH_MAP.forEach((dash, lineType) => {
  DASH_TO_LINE_TYPE_MAP.set(dash.join(","), lineType);
});

export function getLineTypeFromDash(dash: number[] | undefined): LineType {
  if (!dash?.length) return LineType.SOLID;

  const key = dash.slice(0, 2).join(",");
  return DASH_TO_LINE_TYPE_MAP.get(key) ?? LineType.SOLID;
}
